module.exports = __webpack_public_path__ + "img/invoice-float.602f010a.png";